module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_pro_certification-f9a5d0cfe785d6d5f8459fcef9b7d119.svg";